import {Share} from '@mui/icons-material';
import {Box, Grid, Typography} from '@mui/material';

import useReportSummary from '../../../../hooks/providers/useReportSummary';
import Button from '../../../form/buttons/Button/Button';

const SharedDataBlock = () => {
  const {shouldShareCustomData, setIsSummaryShareDataModalOpen, isDataFiltered} = useReportSummary();

  const dataTypeLabel = shouldShareCustomData ? 'du plan personnalisé' : 'du plan général';

  return (
    <Grid item>
      <Grid
        container
        alignItems="center"
        gap={2}
        py={2}
        px={3}
        sx={{
          backgroundColor: '#EEF6FF',
          borderRadius: 3,
          border: '1px solid lightgrey'
        }}
      >
        <Box
          sx={{
            p: 1.3,
            borderRadius: 1,
            backgroundColor: '#DBEAFE'
          }}
        >
          <Share fontSize="small" color="primary" />
        </Box>
        <Grid item flex={1}>
          <Typography fontWeight="bold" fontSize={14}>
            Données {dataTypeLabel} partagées {isDataFiltered ? '(filtrées)' : ''}
          </Typography>
          <Typography fontWeight="bold" fontSize={12} color="text.secondary">
            Configuration actuelle appliquée
          </Typography>
        </Grid>

        <Button color="white" onClick={() => setIsSummaryShareDataModalOpen(true)} size="small" variant="contained">
          Modifier
        </Button>
      </Grid>
    </Grid>
  );
};

export default SharedDataBlock;
